export default __webpack_public_path__ + "static/media/caret-left.8e3c1f34.svg";